import { RouteNames } from "../types/names";
import type { AppRouteRecordRaw } from "../types/types";

import { PERMISSIONS } from "@/shared/permissions";

const channelRoutes: AppRouteRecordRaw[] = [
  {
    path: "/channels",
    name: RouteNames.CHANNELS,
    component: () => import("@/pages/ChannelsPage.vue"),
    meta: {
      permissions: [PERMISSIONS.CHANNELS_READ],
      title: "Channels",
      menuTitle: "Channels",
      menuIcon: "lucide:radio-tower",
      menuOrder: 10,
      showInMenu: true,
      menuGroup: "Commerce",
      menuGroupIcon: "lucide:shopping-bag",
      menuGroupOrder: 40,
    },
  },
  {
    path: "/channels/new",
    name: RouteNames.CHANNEL_CREATE,
    component: () => import("@/pages/ChannelCreatePage.vue"),
    meta: {
      // Creating a channel requires write permission — read-only users are redirected to /403.
      permissions: [PERMISSIONS.CHANNELS_WRITE],
      title: "Add Channel",
      showInMenu: false,
    },
  },
  {
    path: "/channels/:id",
    name: RouteNames.CHANNEL_DETAIL,
    component: () => import("@/pages/ChannelDetailPage.vue"),
    meta: {
      permissions: [PERMISSIONS.CHANNELS_READ],
      title: "Channel Details",
      showInMenu: false,
    },
  },
];

export default channelRoutes;
